import { Slider } from 'components/molecules/Slider'
import { Section } from 'components/organisms/Section'
import type { TestimonialsProps } from './types'
import { Button, EButtonVariant } from 'components/atoms/Button'
import { cn } from 'lib/utils'

import './index.scss'

const mainClass = 'testimonials'

export const Testimonials = ({
  title,
  subtitle,
  note,
  action,
  list = [],
}: TestimonialsProps) => {
  const shouldHideArrows = list.length <= 3
  if (!list.length) {
    return null
  }

  return (
    <Section
      id="_testimonials"
      className={mainClass}
      title={title}
      subtitle={subtitle}
      note={note}
      action={action}
    >
      <Slider variableWidth className={cn(`${mainClass}__slider`, shouldHideArrows && `${mainClass}__slider--no-arrows`)}>
        {list.map((item) => (
          <div key={item.id} className={`${mainClass}__card`}>
            <p className={`${mainClass}__text`}>{item.text}</p>
            <footer className={`${mainClass}__footer`}>
              {item.link.href ? (
                <Button
                  href={item.link.href}
                  variant={EButtonVariant.LINK}
                  className={`${mainClass}__link`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.link.text}
                </Button>
              ) : (
                item.link.text
              )}
            </footer>
          </div>
        ))}
      </Slider>
    </Section>
  )
}
